import React from 'react';

export default function EmptyState({ title, description, icon, action, className = '' }) {
  return (
    <div className={`app-empty-state ${className}`.trim()}>
      {icon && (
        <div className="app-empty-state__icon" aria-hidden>
          {icon}
        </div>
      )}
      {title && <div className="app-empty-state__title">{title}</div>}
      {description && <div className="app-empty-state__description">{description}</div>}
      {action && <div className="app-empty-state__action">{action}</div>}
    </div>
  );
}
